import { useState } from "react";
import Logo from "@/components/base/Logo";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: "Accueil", href: "/" },
    { label: "Réparation", href: "/reparation-volet-roulant" },
    { label: "Dépannage urgence", href: "/depannage-urgence" },
    { label: "Motorisation", href: "/motorisation-somfy" },
    { label: "Pose", href: "/pose-volet-roulant" },
    { label: "Tarifs", href: "/tarifs" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-brand-border transition-all duration-300"
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center">
            <div className="hidden md:block">
              <Logo />
            </div>
            <div className="md:hidden">
              <Logo variant="compact" />
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-brand-text text-[15px] font-medium hover:text-brand-cyan transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="tel:0374473240"
              className="hidden md:flex items-center justify-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-colors bg-brand-cyan text-white hover:bg-brand-cyan/90"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-base"></i></span>
              03 74 47 32 40
            </a>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-brand-blue"
              aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
              type="button"
            >
              {isOpen ? (
                <i className="ri-close-line text-2xl"></i>
              ) : (
                <i className="ri-menu-line text-2xl"></i>
              )}
            </button>

            <a
              href="tel:0374473240"
              className="md:hidden flex items-center gap-1 bg-brand-cyan text-white px-2 py-1.5 rounded-full text-xs font-semibold min-w-0 hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-sm"></i></span>
              03 74 47 32 40
            </a>
          </div>
        </div>
      </div>

      {isOpen && (
        <div id="mobile-menu" className="md:hidden bg-white border-t border-brand-border" role="navigation" aria-label="Menu principal mobile">
          <nav className="flex flex-col px-4 py-4 gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-brand-text text-base font-medium py-3 px-2 hover:text-brand-cyan transition-colors border-b border-brand-border last:border-0"
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}